import { useCounters, useOpenlinesMe } from './api';

/** The signed-in user works in a line (or manages them): the messenger tab, the nav item and the top-bar widget show. */
export function useIsOperator(): boolean {
  const me = useOpenlinesMe();
  return !!me.data && (me.data.isOperator || me.data.canManage);
}

/** Dialogs waiting for the user: the queue of their lines and their own dialogs with unread client messages. */
export function useWaitingCount(): number | undefined {
  const operator = useIsOperator();
  const counters = useCounters(operator);
  if (!operator || !counters.data) return undefined;
  return counters.data.queue + counters.data.unread;
}
